export interface Item {
    title?: string;
    route?: string;
    displayOrder?: number;
    uriComponent?: string;
    type?: NavigationItemType;
}

export enum NavigationItemType {
    Navigation,
    Dashboard,
    Workflow,
    ExternalLink
}